import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { Box, IconButton, List, Popover, Typography } from '@mui/material';
import { FC, MouseEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// styles, interfaces
import { handleLogout } from 'lib/helper';
import { LOG_OUT_BUTTON_TEXT, SETTINGS_ROUTE, SETTINGS_TEXT } from 'constants/index';
import { useAuthContext } from 'contexts/AuthContext';
import { Nullable } from 'interfaces';
import { avatarBox, cursorPointer, popoverListItemLabel } from 'styles/commonComponentStyle';
import { LightGreyCardBox, UserSettingListItem } from 'theme/styleComponent';
import { flexCenter, textTruncate } from 'theme/styleConstant';

const UserProfilePopover: FC = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<Nullable<HTMLElement>>(null);
  const { currentUser } = useAuthContext();
  const { firstName, email } = currentUser || {};

  const open = Boolean(anchorEl);
  const id = open ? 'user-popover' : undefined;

  const handleClick = (event: MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const logoutHandler = () => {
    handleLogout();
  };

  const handleNavigate = (path: string) => {
    navigate(path);
    handleClose();
  };

  return (
    <>
      <LightGreyCardBox {...flexCenter} aria-describedby={id} onClick={handleClick} sx={cursorPointer}>
        <IconButton sx={avatarBox}>{firstName?.charAt(0).toUpperCase() || ''}</IconButton>
        <Box ml={2}>
          <Typography variant="subtitle2" sx={textTruncate}>
            {firstName}
          </Typography>
          <Typography
            variant="subtitle2"
            fontWeight="400"
            color={(theme) => theme.palette.customGrayColor.light}
            sx={textTruncate}>
            {email}
          </Typography>
        </Box>
        <IconButton>
          <KeyboardArrowRightIcon />
        </IconButton>
      </LightGreyCardBox>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        sx={popoverListItemLabel}>
        <List>
          <UserSettingListItem onClick={() => handleNavigate(SETTINGS_ROUTE)}>
            <SettingsIcon />
            {SETTINGS_TEXT}
          </UserSettingListItem>
          <UserSettingListItem onClick={logoutHandler}>
            <LogoutIcon />
            {LOG_OUT_BUTTON_TEXT}
          </UserSettingListItem>
        </List>
      </Popover>
    </>
  );
};

export default UserProfilePopover;
